module.exports = __webpack_public_path__ + "/build/web/images/testimonials-left-1-2-mobile@2x.b48338957afed3db8b86594544b1e82d.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/testimonials-left-1-2-mobile@2x.jpg
// module id = 195
// module chunks = 13